
// 统一管理接口模块

import System from './modules/system'; // 系统管理接口模块
import Dictionary from './modules/dictionary'; // 字典表接口模块
import Engineer from './modules/engineer'; // 工程项目管理接口模块
import Supplier from './modules/supplier'; // 供应商管理接口模块
import Rebar from './modules/rebarManage'; //钢筋管理接口模块
import Auxiliary from './modules/auxiliary'; // 辅材管理接口模块
import Personnerl from './modules/personnerl'; // 人员管理模块
import Materials from './modules/materials'; // 物资管理模块
import Basics from './modules/basics'; // 基础信息管理模块
import Production from './modules/production' // 生产计划管理模块
import Ducts from './modules/ductRaw'; // 管片原料理论放量接口模块
import Notice from './modules/notice'; // 系统公告接口模块
import Project from './modules/project';// 项目管理模块
import Print from './modules/print';// 生产终端管理模块
import Reinforce from './modules/reinforcement'//钢筋笼管理模块
import DuctpiecePLM from './modules/ductpiecePLM' // PLM管理模块
import Device from './modules/device' // 设备管理
import Report from './modules/report' // 报表中心模块
import Analyse from './modules/analyse'; // 数据分析模块
import Safety from './modules/safety'; // 安全管理模块
import Scan from './modules/scan'; // 扫码跳转到对应页面
import screenCms from './modules/screenCms'; // 数字大屏-运维系统
import Tray from './modules/trays'; // 托盘管理模块
import Chain from './modules/chain'; // 连锁块项目管理模块
import Group from './modules/group'; // 班组管理模块
import ChainTheory from './modules/chainTheory'; // 连锁块理论放量管理模块
import MaterialStock from './modules/materialStock'; // 原料管理库存管理模块
import Block from './modules/block'; // 连锁块管理模块
import Dists from './modules/dists'; // 打包块管理模块



export default {
  System,
  Dictionary,
  Engineer,
  Personnerl,
  Supplier,
  Rebar,
  Materials,
  Basics,
  Auxiliary,
  Production,
  Ducts,
  Notice,
  Project,
  Print,
  Reinforce,
  DuctpiecePLM,
  Device,
  Report,
  Analyse,
  Safety,
  Scan,
  screenCms,
  Tray,
  Chain,
  Group,
  ChainTheory,
  MaterialStock,
  Block,
  Dists,
}
